import { Outlet } from 'react-router-dom';
import type { FC } from 'react';

const ClientPage: FC = () => <Outlet />;

export default ClientPage;
